import React, { memo } from 'react';
export const PainSection = () => {
  const items = ['Ves que cada día está más quieto/a, más callado/a, más lejos de vos... y no sabés cómo frenarlo.', 'Buscás actividades en internet pero encontrás información suelta que no podés aplicar en casa.', 'El médico te da indicaciones generales pero en casa necesitás herramientas concretas para el día a día.', 'Sabés que la memoria y el movimiento se trabajan, pero no tenés un sistema claro para empezar.', 'Cargás con todo el peso del cuidado solo/a y el agotamiento ya se está notando.'];
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-161">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-162">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12 leading-tight" data-id="element-163">
          ¿Te resulta familiar alguna de estas situaciones?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-164">
          {items.map((item, i) => <div key={i} className="bg-familia-bg border border-familia-red/15 p-5 md:p-6 rounded-xl flex items-start gap-4" data-id="element-165">
              <span className="text-familia-red text-xl shrink-0" data-id="element-166">❌</span>
              <p className="text-familia-gray leading-relaxed text-[15px]" data-id="element-167">
                {item}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};